// extracted by mini-css-extract-plugin
export default {"sort-by-select":"sort-by-select__sort-by-select--TnoLl","sortBySelect":"sort-by-select__sort-by-select--TnoLl"};